// extracted by mini-css-extract-plugin
module.exports = {"ListOfForumsRight":"qo_a","ListOfForumsRight__brandDaysPosts":"qo_b bhv_rq"};